import { useRef, useState, useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { withDefaultProviders } from 'src/hocs'
import { useCookie } from 'src/hook/useCookie'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import api from 'src/services/api'
import { useSessionData } from 'src/hook/useSessionData'
import { Content, Drawer } from '../userProfile/userProfile.styles'
import { Activities, Header, Highlights, Interests, UserInfo } from '../userProfile/components'
import { useUserProfile, useUserProfileActions } from './hooks'

const GlobalUserProfile = () => {
  const { pathname } = useLocation()
  const [hasViewAsBar, setHasViewAsBar] = useState(false)
  const drawerRef = useRef<HTMLDivElement>(null)
  const { isLoggedUser, onKeyDown } = useUserProfileActions()
  const { visible, userUcode, onClose } = useUserProfile()
  const { user } = useSessionData()
  const { value: theme } = useCookie<ThemeMode>({
    name: 'theme',
    defaultValue: ThemeMode.DARK,
    observeChanges: true
  })

  useEffect(() => {
    if (visible) {
      const handleFocusInSidebar = () => {
        const sidebar = document.querySelector('[slot="header"]') as HTMLElement
        setHasViewAsBar(sidebar?.offsetTop > 0)
        drawerRef?.current?.focus()
      }

      handleFocusInSidebar()
    }
  }, [visible, userUcode])

  useEffect(() => {
    onClose()
  }, [pathname])

  useEffect(() => {
    if (!isLoggedUser) {
      onClose()
    }
  }, [isLoggedUser])

  useLayoutEffect(() => {
    /**
     * TODO: O header Authorization foi forçado porque o hook
     * `src/components/userProfile/hooks/useGetUserPosts/useGetUserPosts.ts`
     * ainda não utiliza o hook da lib `@hotmart-org-ca/hot-club-http`.
     *
     * Esse ajuste só poderá ser removido quando a lib suportar esse recurso.
     */
    const setUserToken = () => {
      api.defaults.headers.common.Authorization = `Bearer ${user?.token}`
    }

    setUserToken()
  }, [user])

  return (
    <Drawer
      ref={drawerRef}
      data-test="drawer"
      className="_position-fixed _shadow"
      theme={theme}
      visible={visible}
      hasViewAsBar={hasViewAsBar}
      role="complementary"
      tabIndex={-1}
      aria-hidden={!visible}
      onKeyDown={onKeyDown}
    >
      <Header />
      <UserInfo />

      <Content className="_position-relative _overflow-auto">
        <Interests />
        <Highlights />
        <Activities theme={theme} />
      </Content>
    </Drawer>
  )
}

const GlobalUserProfileWithProviders = withDefaultProviders(GlobalUserProfile)

export default GlobalUserProfileWithProviders
